import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';
import { FlexibleDropdownConfig } from 'app/shared/components/flexible-dropdown/flexible-dropdown.component';

@Injectable()
export class ContactService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {
    }

    addContact(data: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.contact.add.api;
        return this.requestService.post(url, data);
    }

    listContactsDictionary(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.contact.dictionary.api;
        return this.requestService.get(url);
    }

    getClassExamContactPersonFlexConfig(): any {
        let config = new FlexibleDropdownConfig();
        config.label = 'Contact Person';
        config.placeholder = 'Select contact...';
        config.required = true;
        config.forceRefresh = Observable.never();
        config.addLabel = 'Add New Contact';
        config.tooltip = 'classes.edit.exams.contactPerson';
        config.dictionaryFactory = () => this.listContactsDictionary().map(body => body.data);
        config.addFactory = (data) => this.addContact(data).map(body => ({ key: body.data.id, value: body.data.name }));
        config.questions = [
            { key: 'name', label: 'Name', required: true },
            { key: 'email', label: 'Email', required: true },
            { key: 'phone', label: 'Phone', required: true }
        ];

        return config;
    }

    getClassExamProctorFlexConfig(): any {
        let config = new FlexibleDropdownConfig();
        config.label = 'Proctor';
        config.placeholder = 'Select proctor...';
        config.forceRefresh = Observable.never();
        config.required = true;
        config.addLabel = 'Add New Proctor';
        config.tooltip = 'classes.edit.exams.proctor';
        config.dictionaryFactory = () => this.listContactsDictionary().map(body => body.data);
        config.addFactory = (data) => this.addContact(data).map(body => ({ key: body.data.id, value: body.data.name }));
        config.questions = [
            { key: 'name', label: 'Name', required: true },
            { key: 'email', label: 'Email', required: true },
            { key: 'phone', label: 'Phone', required: true }
        ];

        return config;
    }
}



// WEBPACK FOOTER //
// ./src/app/solar/common/services/contact.service.ts